// src/pages/FAQPage.jsx
import React from 'react';
import LegalLayout from '../components/LegalLayout';
import Seo from '../components/Seo';

const FAQPage = () => {
  // Structure de données pour les catégories de FAQ et leurs questions/réponses
  const faqCategories = [
    {
      title: 'Général',
      questions: [
        {
          question: 'Qu\'est-ce que "Y A Quoi A Manger" (YAQAM) ?',
          answer: '"Y A Quoi A Manger" (YAQAM) est une application qui  pour générer des plans de repas personnalisés selon vos préférences, créer automatiquement des listes de courses et commander bientôt directement auprès de votre drive préféré.'
        },
        {
          question: 'Comment fonctionne "Y A Quoi A Manger" (YAQAM) ?',
          answer: 'YAQAM analyse vos préférences alimentaires, allergies et objectifs nutritionnels pour créer un plan de repas adapté. L\'application génère ensuite une liste de courses optimisée et peut même bientôt passer la commande automatiquement auprès d\'un service de drive partenaire.'
        },
        {
          question: 'Quels sont les avantages de "Y A Quoi A Manger" (YAQAM) ?',
          answer: `
            <ul class="list-disc pl-5 space-y-1">
              <li>Gain de temps considérable dans la planification de vos repas</li>
              <li>Découverte de nouvelles recettes adaptées à vos goûts</li>
              <li>Réduction du gaspillage alimentaire grâce aux suggestions anti-gaspi</li>
              <li>Simplification de vos courses hebdomadaires</li>
              <li>Équilibre nutritionnel respecté selon vos objectifs</li>
            </ul>
          `
        },
        {
          question: 'Est-ce que "Y A Quoi A Manger" (YAQAM) fonctionne sur mobile ?',
          answer: 'Oui, notre application est accessible depuis tous les appareils via notre site web responsive. Une application mobile native sera disponible prochainement.'
        }
      ]
    },
    {
      title: 'Abonnement et tarifs',
      questions: [
        {
          question: 'Est-ce que "Y A Quoi A Manger" (YAQAM) est gratuit ?',
          answer: 'Nous proposons une version gratuite qui vous permet de générer jusqu\'à 3 repas par semaine et d\'obtenir une liste de courses basique. Pour accéder à toutes les fonctionnalités, nous proposons un abonnement Premium à 9,99€/mois.'
        },
        {
          question: 'Que comprend l\'abonnement Premium ?',
          answer: `
            <p>L'abonnement Premium inclut :</p>
            <ul class="list-disc pl-5 space-y-1 mt-2">
              <li>Planification de repas illimitée</li>
              <li>Personnalisation avancée des recettes</li>
              <li>Commande automatique au drive</li>
              <li>Suggestions de recettes anti-gaspi</li>
              <li>Support client prioritaire</li>
            </ul>
          `
        },
        {
          question: 'Comment puis-je annuler mon abonnement ?',
          answer: 'Vous pouvez annuler votre abonnement à tout moment depuis votre espace personnel dans la section "Abonnement". L\'annulation prendra effet à la fin de la période de facturation en cours.'
        }
      ]
    },
    {
      title: 'Utilisation',
      questions: [
        {
          question: 'Comment personnaliser mes préférences alimentaires ?',
          answer: 'Après votre inscription, vous pouvez définir vos préférences dans la section "Profil" : régimes alimentaires spécifiques, allergies, ingrédients non appréciés, et préférences culinaires.'
        },
        {
          question: 'Comment fonctionnent les commandes au drive ?',
          answer: 'Après avoir validé votre liste de courses, vous pouvez sélectionner "Commander au drive" et choisir votre enseigne préférée. Vous serez redirigé vers le site du drive avec votre panier pré-rempli ou, si vous avez configuré vos identifiants, la commande sera passée automatiquement.'
        },
        {
          question: 'Puis-je modifier un plan de repas généré ?',
          answer: 'Oui, vous pouvez facilement remplacer des recettes, ajuster les portions ou supprimer des repas après la génération du plan.'
        },
        {
          question: 'Comment fonctionne la fonction anti-gaspi ?',
          answer: 'La fonction anti-gaspi vous permet d\'entrer les ingrédients restants dans votre réfrigérateur, et YAQAM vous suggère des recettes créatives pour les utiliser efficacement, réduisant ainsi le gaspillage alimentaire.'
        }
      ]
    },
    {
      title: 'Sécurité et données',
      questions: [
        {
          question: 'Mes données sont-elles sécurisées ?',
          answer: 'Oui, nous utilisons des protocoles de sécurité avancés pour protéger vos informations personnelles. Consultez notre Politique de Confidentialité pour plus de détails.'
        },
        {
          question: 'Comment mes identifiants de drive sont-ils protégés ?',
          answer: 'Nous utilisons un système de jetons (tokens) sécurisés pour communiquer avec les services de drive. Vos mots de passe ne sont jamais stockés en clair dans notre système.'
        },
        {
          question: 'Puis-je supprimer mon compte et mes données ?',
          answer: 'Oui, vous pouvez supprimer votre compte à tout moment depuis la section "Profil". Toutes vos données personnelles seront supprimées conformément à notre Politique de Confidentialité.'
        }
      ]
    }
  ];

  return (
    <>
      <Seo
        title="Foire Aux Questions"
        description="Toutes les réponses aux questions fréquentes sur YAQAM, la planification de repas et les abonnements."
        breadcrumb
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "YAQAM",
            "url": (typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com',
            "logo": "https://www.yaqam.com/img/logo_color-min.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "contactType": "customer support",
              "email": "info@j7lab.com"
            }]
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Accueil",
                "item": (typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com'
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "FAQ",
                "item": ((typeof window !== 'undefined' && window.location?.origin) ? window.location.origin : 'https://www.yaqam.com') + '/faq'
              }
            ]
          }
        ]}
      />
      <LegalLayout title="Foire Aux Questions (FAQ)">
      <div className="space-y-8">
        {faqCategories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            <h2 className="text-2xl font-semibold mb-4 text-[#2C3E50] border-b-2 border-[#87A96B]/30 pb-2">
              {category.title}
            </h2>
            
            <div className="space-y-6">
              {category.questions.map((item, itemIndex) => (
                <div key={itemIndex} className="border-b border-gray-100 pb-4 last:border-0 last:pb-0">
                  <h3 className="text-lg font-medium mb-2 text-[#87A96B]">
                    {item.question}
                  </h3>
                  <div 
                    className="text-[#2C3E50] leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <style jsx>{`
        :global(.space-y-1 li) {
          color: #2C3E50;
        }
        :global(.list-disc) {
          list-style-type: disc;
        }
        :global(.list-disc li::marker) {
          color: #87A96B;
        }
      `}</style>
    </LegalLayout>
    </>
  );
};

export default FAQPage;
